import { FC } from "react";

interface IconProps {
  color?: string;
}

const Eye: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 16 16" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M10.108 8.035a2.108 2.108 0 1 1-4.216 0 2.108 2.108 0 0 1 4.216 0Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      clipRule="evenodd"
      d="M7.999 12.903c2.538 0 4.86-1.825 6.168-4.868-1.308-3.042-3.63-4.868-6.168-4.868H8c-2.538 0-4.86 1.826-6.168 4.868 1.308 3.043 3.63 4.868 6.168 4.868H8Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Eye;
